<template>
    <div>
        <img alt="Platform Light" class="h-auto w-40 mx-auto" src="/assets/logo.png">
    </div>
</template>
<script>
export default {
    name: 'AuthenticationCardLogo',
    props: {
        errors: Object,
    },
}
</script>
